import React, { type ComponentPropsWithoutRef } from 'react';

import { Box } from '@betterment/samba-react';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

type BaseProps = {
  children: React.ReactNode;
  css?: SystemStyleObject;
};

type WorkflowCardProps = BaseProps &
  ComponentPropsWithoutRef<'div'> & {
    variant?: 'standard' | 'compact';
  };

export const WorkflowCard = ({ variant = 'standard', children, css: cssProp, ...props }: WorkflowCardProps) => {
  const padding = variant === 'compact' ? 'space.150' : 'space.300';

  return (
    <Box
      css={{
        borderWidth: { base: 'none', sm: 'thin' },
        borderStyle: 'solid',
        borderColor: 'border.weak',
        borderRadius: 'medium',
        padding: { base: 'space.0', sm: padding },
        ...cssProp,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

WorkflowCard.displayName = 'WorkflowCard';
